import React, {useMemo} from 'react';
import type {SxProps} from '@mui/material';
import {useTheme} from '@mui/material';
import {useLocalization} from 'localization';
import {Icon, Layout, Spacer, Text} from 'components';
import type {EditorMode} from '../../types';

type Props = {
  mode: EditorMode;
};

export const SearchAgentError: React.FC<Props> = ({mode}) => {
  const {t} = useLocalization();
  const {colors} = useTheme();

  const errorContainerSx: SxProps = useMemo(
    () => ({
      // height: 10,
      padding: 2,
      borderRadius: 2,
      backgroundColor: colors.warning40,
    }),
    [colors],
  );

  const guideContainerSx: SxProps = useMemo(
    () => ({
      padding: 2,
      borderRadius: 2,
      backgroundColor: colors.offWhite,
    }),
    [colors],
  );
  return (
    <Layout sx={errorContainerSx}>
      <Layout horizontal adjustCenter adjustLeft>
        <Icon icon="Info" />
        <Spacer size={1} />
        <Text variant="h3">
          {t('wizard.agent.step.1.search.failed.message')}
        </Text>
      </Layout>
      <Spacer size={2} />
      <Layout horizontal sx={guideContainerSx} adjustCenter adjustLeft>
        <Icon icon="RadioOn" />
        <Spacer size={1} />
        <Text variant="body1">
          {t(`wizard.agent.step.1.${mode}.search.failed.guide`)}
        </Text>
      </Layout>
    </Layout>
  );
};
